import { useExperience } from "../../../../../shared/context/ExperienceContext";
import { Icons } from "../../../../../shared/icons/icons";
import { getModeThemeConfig } from "../../../../../shared/config/mode-theme.config";
import AppButton from "../../../../../shared/components/ui/AppButton/AppButton";
import SectionHeading from "../../../../../shared/components/ui/SectionHeading/SectionHeading";
import "./FinalCtaSection.css";

const finalCtaByMode = {
  all: {
    eyebrow: "Reserve seu momento",
    title: (
      <>
        Sua jornada de <span>cuidados</span> começa agora
      </>
    ),
    description:
      "Agende seu atendimento e descubra o melhor caminho para unir bem-estar, autoestima e um cuidado pensado para você.",
    primaryButton: "Agendar atendimento",
    secondaryButton: "Conhecer serviços",
    whatsappKey: "scheduling",
  },
  aesthetics: {
    eyebrow: "Reserve seu momento",
    title: (
      <>
        Seu próximo momento de <span>autocuidado</span> começa agora
      </>
    ),
    description:
      "Agende sua avaliação e descubra os procedimentos ideais para valorizar sua beleza com leveza, segurança e naturalidade.",
    primaryButton: "Agendar avaliação estética",
    secondaryButton: "Ver procedimentos",
    whatsappKey: "aesthetics",
  },
  nutrition: {
    eyebrow: "Reserve seu momento",
    title: (
      <>
        Seu próximo passo com mais <span>saúde</span> começa agora
      </>
    ),
    description:
      "Agende sua consulta e descubra um acompanhamento nutricional mais estratégico, leve e adaptado à sua rotina.",
    primaryButton: "Agendar consulta nutricional",
    secondaryButton: "Ver acompanhamentos",
    whatsappKey: "nutrition",
  },
};

const highlights = [
  {
    text: "Atendimento personalizado",
    Icon: Icons.User,
  },
  {
    text: "Planos adaptados à sua rotina",
    Icon: Icons.Leaf,
  },
  {
    text: "Acompanhamento próximo",
    Icon: Icons.Heart,
  },
  {
    text: "Resultados reais e sustentáveis",
    Icon: Icons.BarChart,
  },
];

export default function FinalCtaSection() {
  const { mode } = useExperience();
  const content = finalCtaByMode[mode] || finalCtaByMode.all;
  const theme = getModeThemeConfig(mode);

  const description = content.description.includes("estratégico") ? (
    <>
      Agende sua consulta e descubra um acompanhamento nutricional mais{" "}
      <strong>estratégico, leve e adaptado à sua rotina.</strong>
    </>
  ) : (
    content.description
  );

  return (
    <section className="final-cta-section">
      <div className="container final-cta-section__content">
        <div className="reveal-on-scroll reveal-on-scroll--up reveal-delay-1">
          <SectionHeading
            eyebrow={content.eyebrow}
            title={content.title}
            description={description}
            className="final-cta-section__heading"
          />
        </div>

        <div className="final-cta-section__actions reveal-on-scroll reveal-on-scroll--up reveal-delay-2">
          <AppButton
            whatsappKey={content.whatsappKey}
            icon={theme.buttonIcon}
            iconRight={Icons.ChevronRight}
            className="final-cta-btn final-cta-btn--primary"
          >
            {content.primaryButton}
          </AppButton>

          <AppButton
            to="/services"
            variant="secondary"
            icon={theme.secondaryButtonIcon}
            className="final-cta-btn final-cta-btn--secondary"
          >
            {content.secondaryButton}
          </AppButton>
        </div>

        <div className="final-cta-section__highlights">
          {highlights.map(({ text, Icon }, index) => (
            <div
              className={`final-cta-section__highlight reveal-on-scroll reveal-on-scroll--scale reveal-delay-${
                (index % 4) + 1
              }`}
              key={text}
            >
              <span>
                <Icon />
              </span>

              <p>{text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}